<template>
  <svg :viewBox="`0 0 ${size} ${size}`" :style="{height: size + 'px', width: size + 'px', margin: '0 auto'}">
    <path v-for="s in segs" :key="s.label" v-tip="s.tip" :d="s.d" :fill="s.c" stroke="var(--sd-card)" stroke-width="2" />
    <text v-if="center" :x="r" :y="r + 1" text-anchor="middle" fill="var(--sd-ink)" :font-size="size * .185" font-weight="800">{{ center }}</text>
    <text v-if="sub" :x="r" :y="r + size * .14" text-anchor="middle" fill="var(--sd-ink-3)" :font-size="size * .088">{{ sub }}</text>
  </svg>
</template>
<script>
import { fmt, pctHtml, esc } from '../../lib/format.js'
export default {
  name: 'SdDonut',
  props: { items: { type: Array, default: () => [] }, size: { type: Number, default: 128 }, center: { type: String, default: '' }, sub: { type: String, default: '' } },
  computed: {
    r() { return this.size / 2 },
    segs() {
      const r = this.r, ir = r * 0.66, tot = this.items.reduce((a, b) => a + (b.v || 0), 0) || 1; let a0 = -Math.PI / 2
      return this.items.map((it) => {
        const frac = (it.v || 0) / tot, a1 = a0 + frac * Math.PI * 2, large = (a1 - a0) > Math.PI ? 1 : 0
        const P = (ang, rad) => [r + rad * Math.cos(ang), r + rad * Math.sin(ang)]
        const [x0, y0] = P(a0, r), [x1, y1] = P(a1, r), [x2, y2] = P(a1, ir), [x3, y3] = P(a0, ir)
        const seg = { label: it.label, c: it.c, d: `M${x0},${y0} A${r},${r} 0 ${large} 1 ${x1},${y1} L${x2},${y2} A${ir},${ir} 0 ${large} 0 ${x3},${y3} Z`,
          tip: `<b>${esc(it.label)}</b><br>${fmt(it.v)} · ${pctHtml(Math.round((it.v || 0) / tot * 1000) / 10)}` }
        a0 = a1; return seg
      })
    },
  },
}
</script>
